import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://mahua.example.com${item.href}`, name: item.label }
      : { '@id': 'https://mahua.example.com', name: item.label },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-500">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}